module.exports = __webpack_public_path__ + "static/img/MV1.cbc5f36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/MV1.jpg
// module id = jaf4
// module chunks = 0